import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import { StyleSheet, TouchableOpacity } from 'react-native';

import { theme } from '@garnish/constants';
import { BodyText } from '@garnish/core';

// ─────────────────────────────────────────────────────────────────────────────

export const UpsellSeeMore = (props: Props) => {
  const { onPress } = props;

  return (
    <TouchableOpacity accessibilityRole="button" style={styles.button} onPress={onPress}>
      <BodyText sizeMatch={['18']} style={styles.text}>
        <FormattedMessage {...messages.seeMore} />
      </BodyText>
    </TouchableOpacity>
  );
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  seeMore: {
    defaultMessage: 'See more',
    description: 'Upsell modal | Product options | See more',
  },
});

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  button: {
    width: 400,
    alignItems: 'center',
    alignSelf: 'center',
    marginBottom: theme.spacing['4'],
    paddingVertical: theme.spacing['4'],
  },
  text: {
    color: theme.colors.KALE,
  },
});

// ─────────────────────────────────────────────────────────────────────────────

type Props = {
  onPress: () => void;
};
